import { Outlet } from 'react-router-dom';
import { DateRangeProvider } from '../../contexts/DateRangeContext';
import { AgentFilterProvider } from '../../contexts/AgentFilterContext';
import { AgentServiceProvider } from '../../contexts/AgentServiceContext';
import { AgentLabelsProvider } from '../../contexts/AgentLabelsContext';
import { geminiService } from '../../services/gemini/geminiService';

export const WORKSPACE_LABELS = {
  module: 'gemini_workspace',
  noun: 'Application',
  nounPlural: 'Applications',
  pageTitle: 'Workspace Interactions',
  pageSubtitle: 'Explore Gemini interactions across Google Workspace applications',
  totalStatHelp: 'Total number of Gemini interactions across all Google Workspace applications',
  totalStatTrend: 'All applications combined',
  unknownLabel: 'Unknown App',
  responseSenderFallback: 'Gemini',
  hasAgentFilter: true,
  // Workspace Reports API gives activity metadata only (no prompt/response
  // content), so content-derived dashboard sections (semantic/session
  // intelligence, threats, PII, knowledge gaps) stay empty — hide them.
  hasContent: false,
  licenseCostLabel: 'Google Workspace License Cost ($/user/month)',
  licenseCostHelp: 'Monthly cost per Google Workspace with Gemini license.',
  licenseCostSubtitle: 'Per-user monthly Google Workspace Gemini license cost',
  routeBase: '/gemini',
};

const GeminiWorkspaceLayout = () => (
  <DateRangeProvider>
    <AgentFilterProvider storageKey="gemini_workspace_filters">
      <AgentServiceProvider value={geminiService}>
        <AgentLabelsProvider value={WORKSPACE_LABELS}>
          <Outlet />
        </AgentLabelsProvider>
      </AgentServiceProvider>
    </AgentFilterProvider>
  </DateRangeProvider>
);

export default GeminiWorkspaceLayout;
